import api from "../../utils/api/api.utils";
export var getCards = function () { return api.get("/cards"); };
export var closeCard = function (id) { return api.post("/cards/".concat(id, "/close")); };
